<template>
  <div class="d-flex align-items-center justify-content-around mx-1">
    <v-select
      class="time-picker"
      :clearable="false"
      :value="hour"
      :options="optionHours"
      autowidth
      @input="updateTime($event, 'hour')"
    >
      <template v-slot:open-indicator="{ attributes }">
        <span v-bind="attributes"><font-awesome-icon icon="angle-down" /></span>
      </template>
    </v-select>
    <span>:</span>
    <v-select
      class="time-picker"
      :clearable="false"
      :value="minute"
      :options="optionMinutesSeconds"
      @input="updateTime($event, 'minute')"
    >
      <template v-slot:open-indicator="{ attributes }">
        <span v-bind="attributes"><font-awesome-icon icon="angle-down" /></span>
      </template>
    </v-select>
    <span>:</span>
    <v-select
      class="time-picker"
      :clearable="false"
      :value="second"
      :options="optionMinutesSeconds"
      @input="updateTime($event, 'second')"
    >
      <template v-slot:open-indicator="{ attributes }">
        <span v-bind="attributes"><font-awesome-icon icon="angle-down" /></span>
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  props: {
    minuteEvent: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      date: null,
      hour: "00",
      minute: "00",
      second: "00",
    };
  },
  computed: {
    optionHours() {
      let hours = [];
      for (let index = 0; index < 24; index++) {
        let hour = this.addZero(index);
        hours.push(hour);
      }
      return hours;
    },
    optionMinutesSeconds() {
      let hours = [];
      for (let index = 0; index < 60; index++) {
        let minSec = this.addZero(index);
        hours.push(minSec);
      }
      return hours;
    },
  },
  created() {
    this.toUtc();
    this.setTime();
  },
  methods: {
    setTime() {
      let hour = this.$moment(this.date).get("hour").toString();
      this.hour = this.addZero(hour);
      let minute = this.$moment(this.date).get("minute").toString();
      this.minute = this.addZero(minute);
      let second = this.$moment(this.date).get("second").toString();
      this.second = this.addZero(second);
    },
    updateTime(value, type) {
      this[type] = value;

      this.date = this.$moment(this.date)
        .set(type, parseInt(value, 10))
        .format("YYYY-MM-DDTHH:mm:ssZ");

      this.$emit("change", this.date);
    },
    addZero(num) {
      num = num.toString();
      if (num.length < 2) {
        num = "0" + num;
      }
      return num;
    },
    toUtc() {
      /*
       * This function will make sure that old meeting data that has no timezone will have UTC
       */
      if (this.minuteEvent.date) {
        let utcFormatted = this.$moment
          .parseZone(this.minuteEvent.date)
          .utcOffset(0, true)
          .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        this.date = utcFormatted;
      }
    },
  },
};
</script>
